import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    Grid,
    FormControl,
    Autocomplete,
    TextField
} from "@mui/material";
import { Tree } from "react-organizational-chart";
import { TreeNode } from "react-organizational-chart";

const PosicionArbol = ({ organigrama }) => {
    const [root, setRoot] = useState(null);
    const [selectedUnidadSuperior, setSelectedUnidadSuperior] = useState(null);

    useEffect(() => {
        if (selectedUnidadSuperior && typeof window !== "undefined") {
            // Filtrar todos los nodos que tengan el mismo unidadSuperiorValue
            const rootElementos = organigrama.find(
                (node) => node.unidadSuperiorValue === selectedUnidadSuperior
            );

            setRoot(rootElementos);
        } else {
            setRoot(null);
        }

        // Limpiar el estado interno del árbol cuando no hay elementos
        if (!selectedUnidadSuperior && root !== null) {
            setRoot(null);
        }
    }, [organigrama, selectedUnidadSuperior]);

    const handleChangeUnidadSuperior = (newValue) => {
        setSelectedUnidadSuperior(newValue ? newValue.value : null);
    };

    const renderNode = (node) => {
        if (!node || !node.children) {
          return null;
        } else {
          console.log(node);
        }
      
        return (
          <>
            {/* Mapea directamente TreeNode por cada hijo en node.children */}
            {node.children.map((child) => (
              <TreeNode
                key={node.new_posicionid}
                style={{ justifyContent: "center" }}
                label={
                  <div style={{ textAlign: "center" }}>
                    <Grid container direction="column" alignItems="center">
                      <Card
                        sx={{
                          maxWidth: "200px",
                          margin: "8px",
                          textAlign: "center",
                        }}
                      >
                        <CardContent>
                          <Typography variant="subtitle1" sx={{ mt: 1 }}>
                            {child.new_idposicin}
                          </Typography>
                          <Typography variant="subtitle1" sx={{ mt: 1 }}>
                            {child["_new_empleadoactual_value@OData.Community.Display.V1.FormattedValue"]}
                          </Typography>
                          <Typography variant="subtitle1" sx={{ mt: 1 }}>
                            {child["statuscode@OData.Community.Display.V1.FormattedValue"]}
                          </Typography>
                          {/* Agrega verificación para otras propiedades si es necesario */}
                        </CardContent>
                      </Card>
                      {/* {hasDescendants(node) && (
                        <div
                          style={{
                            width: "2px",
                            height: "20px",
                            background: "#ccc",
                          }}
                        />
                      )} */}
                    </Grid>
                  </div>
                }
              >
                {renderNode(child)}
              </TreeNode>
            ))}
          </>
        );
      };
      

    // Primero, usa el nuevoArray en lugar de organigrama
    const uniqueOptions = Array.from(
        new Set(organigrama.map(option => option.unidadSuperiorValue))
    ).map(value => {
        // Encuentra el objeto correspondiente en nuevoArray
        const option = organigrama.find(option => option.unidadSuperiorValue === value);

        return {
            value: option.unidadSuperiorValue,
            label: option.unidadSuperiorLabel,
        };
    });

    const sortedOptions = uniqueOptions.sort((a, b) => {
        const labelA = a.label || ''; // Manejar caso de 'label' undefined
        const labelB = b.label || ''; // Manejar caso de 'label' undefined
        return labelA.localeCompare(labelB);
    });

    return (
        <Grid
            container
            sx={{ mt: 2 }}
            justifyContent="center"
            alignItems="center"
        >
            <Grid item xs={12}>
                <FormControl fullWidth sx={{ marginBottom: 2, padding: 4 }}>
                    <Autocomplete
                        value={sortedOptions.find(
                            (option) => option.value === selectedUnidadSuperior
                        )}
                        onChange={(event, newValue) => handleChangeUnidadSuperior(newValue)}
                        options={sortedOptions}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Seleccione una posición"
                            />
                        )}
                    />
                </FormControl>
                {
                    selectedUnidadSuperior ? (
                        <Tree
                            key={selectedUnidadSuperior}
                            lineColor="#ccc"
                            lineWidth="2px"
                            style={{
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {renderNode(root)}
                        </Tree>
                    ) : null
                }

            </Grid>
        </Grid>
    );
};

export default PosicionArbol;